import { render, staticRenderFns } from "./DraggableOptions.vue?vue&type=template&id=2f6b8458&scoped=true&"
import script from "./DraggableOptions.vue?vue&type=script&lang=js&"
export * from "./DraggableOptions.vue?vue&type=script&lang=js&"
import style0 from "./DraggableOptions.vue?vue&type=style&index=0&id=2f6b8458&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f6b8458",
  null
  
)

export default component.exports